import request from '@aned/request';

const BASE_URL = '/api/prompt';
const DEFAULT_OPTIONS = {
  method: 'POST',
  mergeModuleName: 'tdcs/basic',
  reqType: 'json',
};

/**
 * 统一请求封装
 *
 * @param {string} endpoint 接口路径（以 / 开头）
 * @param {Record<string, any>} params 请求参数
 * @param {Record<string, any>} extraConfig 额外配置
 * @returns {Promise<any>} 请求结果
 */
const requestPrompt = (endpoint, params = {}, extraConfig = {}) => {
  return request(`${BASE_URL}${endpoint}`, {
    ...DEFAULT_OPTIONS,
    body: params,
    ...extraConfig,
  });
};

/**
 * 获取用户提示信息
 *
 * @param {Record<string, any>} params 查询参数
 * @returns {Promise<any>} 接口响应
 */
export const getPrompt = (params = {}) => requestPrompt('/selectPrompt', params);

/**
 * 保存用户已知晓的提示信息
 *
 * @param {Record<string, any>} params 保存参数（包含 promptCode 等）
 * @returns {Promise<any>} 接口响应
 */
export const savePrompt = (params = {}) => {
  const query = params?.promptCode ? `?promptId=${encodeURIComponent(params.promptCode)}` : '';
  return requestPrompt(`/savePrompt${query}`, params);
};

/**
 * 新增提示信息
 *
 * @param {Record<string, any>} params 提示信息内容
 * @returns {Promise<any>} 接口响应
 */
export const addPrompt = (params = {}) => requestPrompt('/add', params);

/**
 * 修改提示信息
 *
 * @param {Record<string, any>} params 更新参数
 * @returns {Promise<any>} 接口响应
 */
export const updatePrompt = (params = {}) => requestPrompt('/update', params);

/**
 * 批量删除提示信息
 *
 * @param {Record<string, any>} params 删除参数（如主键集合）
 * @returns {Promise<any>} 接口响应
 */
export const batchDeletePrompt = (params = {}) => requestPrompt('/batchDelete', params);

/**
 * 分页获取提示信息
 *
 * @param {Record<string, any>} params 分页查询参数
 * @returns {Promise<any>} 接口响应
 */
export const getPromptPage = (params = {}) => requestPrompt('/selectPage', params);
